import { Table as MuiTable } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import React from "react";
import { SxProps, Theme } from "@mui/material/styles";

interface Props {
  header: JSX.Element;
  body: JSX.Element;
  ref?: React.MutableRefObject<any>;
  tableSx?: SxProps<Theme>;
}

const baseTableSx: SxProps<Theme> = {
  borderCollapse: "separate",
  "& .MuiTableCell-stickyHeader": {
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 20,
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    position: "relative",
    zIndex: 1,
  },
};

const Table: React.FC<Props> = ({ header, body, ref, tableSx }) => {
  return (
    <MuiTable
      stickyHeader
      className="relative min-h-[100px]"
      ref={ref}
      sx={{ ...baseTableSx, ...(tableSx as object) }}
    >
      <TableHead>{header}</TableHead>
      <TableBody>{body}</TableBody>
    </MuiTable>
  );
};

export default Table;
